import { NFTEventEligibilityResult, NFTEventTier } from "@models/event";
import { Moonpass } from "@models/moonpass";
import { INFTOwnership, NFTOwnership } from "@models/nft";
import { Transaction } from "@models/payment";
import { apiClient } from "@providers/auth";

export const getEventEligibility = async (
  eventId: string,
  userId: string
): Promise<NFTEventEligibilityResult | null> => {
  const result: NFTEventEligibilityResult = await apiClient.get(
    `/events/${eventId}/user/${userId}/eligibility`
  );
  if (!result || !result.nfts || !result.whitelists) return null;
  result.nfts = result.nfts.map((n) => new NFTOwnership(n as INFTOwnership));
  result.whitelists = result.whitelists.map((n) => new Transaction(n));
  return result;
};

export const checkTierEligibility = (
  tier: NFTEventTier,
  tierNFTs: NFTOwnership[] = [],
  tierWhitelists: Transaction[] = [],
  tierMoonpass: Moonpass[] = []
) => {
  // Token gated
  if (tier.nftConstraint) {
    if (tierNFTs.length == 0) return false;
    if (!tier.validateNFTConstraint(tierNFTs)) return false;
  }

  // Moonpass gated
  if (tier.moonpassConstraint) {
    if (tierMoonpass.length == 0) return false;
  }

  // Whitelisted
  if (tier.whitelistConstraint) {
    let reservedQuantity =
      tierWhitelists.length > 0 ? tierWhitelists.slice(-1)[0].items.length : 0;
    reservedQuantity = Math.min(
      reservedQuantity,
      tier.whitelistConstraint.maxPerUser || reservedQuantity
    );
    if (reservedQuantity > 0) return true;

    // if (tier.whitelistConstraint.end > 0) {
    //   const _isExpired = new Date().valueOf() > tier.whitelistConstraint.end;
    //   if (_isExpired) return false;
    // }

    if (tier.nftConstraint) {
      const eligibleNFTCount = tier.getEligibleNFTCollectionCount(tierNFTs);
      let _maxQuantity = Math.floor(
        eligibleNFTCount / (tier.whitelistConstraint.nftRequirement || 1)
      );
      if (tier.whitelistConstraint.maxPerUser > 0)
        _maxQuantity = Math.min(
          _maxQuantity,
          tier.whitelistConstraint.maxPerUser
        );
      if (_maxQuantity == 0) return false;
    }
  }

  return true;
};
